module.exports = __webpack_public_path__ + "img/8.99b1886.png";